import React, { Component } from 'react';
import { Slider, InputNumber, Row, Col } from 'antd';
import { get } from 'lodash';
import './index.less';

interface IProps {
    min: number;
    max: number;
    onChange: (value: number) => void;
}

interface IState {
    inputValue: number;
}

export class NumberInput extends Component<IProps, IState> {
    static defaultProps = {
        min: 0,
        max: 100,
        onChange: () => {},
    };

    state = {
        inputValue: get(this.props, 'value', 0),
    };

    onChange = (value) => {
        const { onChange } = this.props;
        this.setState({
            inputValue: value,
        });
        onChange(value);
    };

    render() {
        const { inputValue } = this.state;
        const { min, max } = this.props;
        const value = typeof inputValue === 'number' ? inputValue : 0;
        return (
            <Row>
                <Col span={19}>
                    <Slider min={min} max={max} onChange={this.onChange} value={value} />
                </Col>
                <Col span={4} push={1}>
                    <InputNumber
                        className="form-component-number-input"
                        min={min}
                        max={max}
                        value={inputValue}
                        onChange={this.onChange}
                    />
                </Col>
            </Row>
        );
    }
}
